<form [formGroup]="entityForm" (submit)="onSubEntityFormSubmit()">
  <ng-container *ngIf="entityid">
    <h4>Edit "{{ entity[entitylabelkey] }}"</h4>

    <ng-container *ngFor="let element of getFormConfigs()">

      <ng-container *ngIf="element['fieldtype']==='text'">
        <div class="form-group">
          <label>{{element['fieldlabel']}} <span *ngIf="element['language']"
                                                 class="badge bg-light">{{element['language']}}</span></label>
          <input type="text" class="form-control" formControlName="{{element['field']}}"
                 [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"
                 [readonly]="element['readonly']"
          />
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='select'">
        <div class="form-group">
          <label>{{element['fieldlabel']}}</label>
          <select class="form-control" formControlName="{{element['field']}}"
                  [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">
            <option *ngFor="let item of element['choices']" value="{{item['id']}}"
                    [selected]="item['selected'] == true">
              {{item['label']}}
            </option>
          </select>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

    </ng-container>

    <router-outlet></router-outlet>

    <div class="row no-gutters my-4">
      <div class="col-12 my-1 text-end">
        <button type="button" class="btn btn-secondary me-2" (click)="cancelSubFormSubmit()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!entityid">
    <h4>Create</h4>

    <ng-container *ngFor="let element of getFormConfigs()">


      <ng-container *ngIf="element['fieldtype']==='text' && element['field']!=='id'">
        <div class="form-group">
          <label>{{element['fieldlabel']}} <span *ngIf="element['language']"
                                                 class="badge bg-light">{{element['language']}}</span></label>
          <input type="text" class="form-control" formControlName="{{element['field']}}"
                 [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"/>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="element['fieldtype']==='select'">
        <div class="form-group">
          <label>{{element['fieldlabel']}}</label>
          <select class="form-control" formControlName="{{element['field']}}"
                  [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">
            <option *ngFor="let item of element['choices']" value="{{item['id']}}">
              {{item['label']}}
            </option>
          </select>
          <div class="invalid-feedback">
            Mandatory {{element['field']}}
          </div>
        </div>
      </ng-container>


    </ng-container>

    <div class="row no-gutters my-4">
      <div class="col-12 my-1 text-end">
        <button type="button" class="btn btn-secondary me-2" (click)="cancelSubFormSubmit()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create</button>
      </div>
    </div>

  </ng-container>
</form>
